import { Filters, FiltersLayout, DropDownFilter } from 'framework/list';
import { TextField, FullDateField, EnumField } from 'framework/ui/field';
import UploadEmployeeDocButton from '../createupdate/UploadEmployeeDocButton';
import EmployeeDocumentListActions from '../shared/buttons/actions/EmployeeDocumentListActions';
import {
  DOWNLOAD_EMPLOYEE_DOCUMENTS,
  EMPLOYEE_DOCUMENT_CATEGORY,
  EMPLOYEE_DOCUMENT_COMPLIANCE_TYPES_VALUES,
  EMPLOYEE_DOCUMENT_IDENTITY_DOCUMENT_TYPES_VALUES,
  EMPLOYEE_DOCUMENT_OTHER_TYPES_VALUES,
  EMPLOYEE_DOCUMENT_SECTIONS_VALUES,
  EMPLOYEE_DOCUMENT_STAGES_VALUES,
} from '../constants';
import { EnumDropdown } from 'framework/form';
import { DocumentStageBadgeField, DocumentsListWrapper } from 'framework/documentStorage';
import { useDocumentStorageContext } from 'framework/documentStorage';
import { DownloadFileLinkField } from 'domain/shared/artifact/field';
import { EmployeeOfficeField, OfficeCodeFilter } from 'domain/shared/employee';
import { EMPLOYEE_DOCUMENT_HR_TYPES_VALUES } from 'domain/shared/core/constants';

const EmployeeDocumentsList = () => {
  const { searchDocuments } = useDocumentStorageContext();

  const filters = (
    <Filters>
      <FiltersLayout>
        <DropDownFilter source="section" label="Section">
          <EnumDropdown source="section" label="Section" options={EMPLOYEE_DOCUMENT_SECTIONS_VALUES} />
        </DropDownFilter>
        <OfficeCodeFilter source="office" label="Office" />
        <DropDownFilter source="stage" label="Stage">
          <EnumDropdown source="stage" label="Stage" options={EMPLOYEE_DOCUMENT_STAGES_VALUES} />
        </DropDownFilter>

        <DropDownFilter source="category" label="Category">
          <EnumDropdown source="category" label="Category" options={EMPLOYEE_DOCUMENT_CATEGORY} />
        </DropDownFilter>
      </FiltersLayout>
    </Filters>
  );

  return (
    <DocumentsListWrapper
      getDataMethod={searchDocuments}
      filters={filters}
      actions={[<UploadEmployeeDocButton />]}
      itemButtons={[<EmployeeDocumentListActions />]}
    >
      <TextField label="Number" source="metadata.number" width="6%" />
      <EnumField label="Section" source="metadata.section" options={EMPLOYEE_DOCUMENT_SECTIONS_VALUES} width="6%" />
      <EnumField label="Category" source="metadata.category" options={EMPLOYEE_DOCUMENT_CATEGORY} width="6%" />
      <DownloadFileLinkField
        label="File"
        permission={DOWNLOAD_EMPLOYEE_DOCUMENTS}
        width="20%"
        sxButton={{
          minWidth: 0,
          width: '100%',
          justifyContent: 'flex-start',
          overflow: 'hidden',
          '& .files-list__files-name': {
            maxWidth: '100%',
          },
        }}
      />
      <EnumField
        label="Type"
        source="metadata.fileType"
        options={{
          ...EMPLOYEE_DOCUMENT_HR_TYPES_VALUES,
          ...EMPLOYEE_DOCUMENT_OTHER_TYPES_VALUES,
          ...EMPLOYEE_DOCUMENT_IDENTITY_DOCUMENT_TYPES_VALUES,
          ...EMPLOYEE_DOCUMENT_COMPLIANCE_TYPES_VALUES,
        }}
      />
      <EmployeeOfficeField label="Office" source="metadata.office" />
      <FullDateField label="Created at" source="metadata.createdAt" />
      <DocumentStageBadgeField label="Signing stage" source="metadata.stage" />
    </DocumentsListWrapper>
  );
};

export default EmployeeDocumentsList;
